import {getCurrentCompanyUUID} from '@/utils/company'

const STORAGE_PREFIX = 'listPagination';

function getStorageKey(listName) {
    const companyUUID = getCurrentCompanyUUID();
    if (companyUUID === '') {
        throw new Error('Company UUID is required for list pagination');
    }
    return `${STORAGE_PREFIX}:${companyUUID}:${listName}`;
}

export function readListPagination(listName) {
    const storedValue = sessionStorage.getItem(getStorageKey(listName));
    if (storedValue == null) {
        return null;
    }
    const pagination = JSON.parse(storedValue);
    if (!Number.isInteger(pagination.currentPage) || pagination.currentPage < 1) {
        throw new Error('Stored currentPage is invalid');
    }
    if (!Number.isInteger(pagination.pageSize) || pagination.pageSize < 1) {
        throw new Error('Stored pageSize is invalid');
    }
    return pagination;
}

export function writeListPagination(listName, currentPage, pageSize) {
    sessionStorage.setItem(getStorageKey(listName), JSON.stringify({
        currentPage: currentPage,
        pageSize: pageSize
    }));
}
